<app-pre-access-filter-modal
  [fields]="preAccessOnlyFields"
  [tableName]="config.localizationKey"
  [(isVisible)]="isPreAccessModalVisible"
  (filtersApplied)="onPreAccessFiltersApplied($event)"
  (filtersClosed)="onPreAccessFiltersClosed()"
></app-pre-access-filter-modal>

@if (hasPreAccessSelection()) {
  <abp-card class="zn-crud-page">
    <abp-card-body>
      <app-crud-page
        #crudPage
        [tableName]="config.localizationKey"
        [permission]="config.permission"
        [fields]="fields"
        [showPrefilters]="false"
        [dataset]="dataset()"
        [loading]="loading()"
        [loadData]="loadData"
        (createRecord)="create()"
        (deleteRecord)="deleteRecords()"
        (editRow)="edit($event)"
        (saveInMemoryRequested)="onSaveInMemory($event)"
        (selectedItemsChange)="onRowSelection($event)"
        [exportInProgress]="exporting()"
      (exportToExcelRecord)="exportToExcel()"
        [hideCreateButton]="true"
        [disableCanDelete]="true"
        [disableEdit]="true"
        [disableEditInline]="true"
        [disableDuplicate]="true"
      ></app-crud-page>
    </abp-card-body>
  </abp-card>
}

<app-generic-form
  #genericForm
  (payload)="save($event)"
></app-generic-form>
